import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {cloneDeep} from 'lodash';
import Util from '../../util/util';
import {getCantDeleteTaskMessage} from '../../util/TaskUtil';
import {BUTTON_STYLE, BUTTON_COLOR} from '../../../../constants';
import Moment from 'moment';
import DuplicateTaskMutation from '../../../../mutations/duplicate_task_mutation';
import UpdateTaskMutationModern from '../../../../mutations/update_task_mutation.modern';
import DeleteTaskMutation from '../../../../mutations/delete_task_mutation';
import UpdateViewerMutation from '../../../../mutations/update_viewer_mutation.modern';
//import {createToast} from '../../containers/toaster';
import {createToast} from '../toasts/toast';
import {MODAL_TYPE, showModal} from '../modals/generic_modal_conductor';
import {injectIntl} from 'react-intl';
import Warning from '../../../../components/warning';
import ReactDOM from 'react-dom';
import UndoDeleteTaskMutation from '../../../../mutations/UndoDeleteTaskMutation';
import {hasFeatureFlag} from '../../util/FeatureUtil';
import {hasPermission, isClientUser, personIsClientUser} from '../../util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../../Permissions';

class GenericTaskContextMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			focusAtIndex: 0,
			options: [],
		};
		this.getContextMenuOptions = this.getContextMenuOptions.bind(this);
		this.startTimer = this.startTimer.bind(this);
		this.closeContextMenu = this.closeContextMenu.bind(this);
	}
	componentDidMount() {
		if (this.option_0) {
			this.option_0.focus();
		}
		document.addEventListener('wheel', this.closeContextMenu);
	}
	componentDidUpdate(prevProps, prevState) {
		if (prevState.focusAtIndex !== this.state.focusAtIndex && this['option_' + this.state.focusAtIndex]) {
			this['option_' + this.state.focusAtIndex].focus();
		}
	}

	componentWillUnmount() {
		document.removeEventListener('wheel', this.closeContextMenu);
	}

	closeContextMenu() {
		this.props.closeContextMenu();
	}

	// BEGIN Menu options functionality //
	duplicateTask(task) {
		const onSuccess = response => {
			if (this.props.fixedPriceUtil && response && response.duplicateTask && response.duplicateTask.taskEdges) {
				const tasks = response.duplicateTask.taskEdges.map(node => node);
				this.props.fixedPriceUtil.addTasks(tasks);
			}
			createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'task_modal.has-been-duplicated'})});
		};
		Util.CommitSchedulingModalUpdate(
			DuplicateTaskMutation,
			{
				taskId: task.id,
				supportTaskHierarchy: true,
				companyId: this.props.viewer.company.id,
				projectId: this.props.viewer.project ? this.props.viewer.project.id : task.project.id,
				filter: this.props.isConnectedParent ? task.statusColumnV2.projectGroupStatusColumnId : task.statusColumnV2.id,
				viewerId: this.props.viewer.id,
				viewer: this.props.viewer
			},
			onSuccess
		);
	}

	deleteTask(task) {
		const {formatMessage} = this.props.intl;
		const useUndoDelete = hasFeatureFlag('undo_task_delete', this.props.viewer.availableFeatureFlags);
		if (this.props.viewer.timerStartDate && this.props.viewer.timerTask && task.id === this.props.viewer.timerTask.id) {
			this.stopTimer(task, true);
			return;
		}
		const onSuccess = () => {
			createToast({
				duration: 4000,
				message: this.props.intl.formatMessage({id: 'task_modal.has-been-deleted'}),
				actionText: useUndoDelete ? 'Undo' : null,
				actionCallback: useUndoDelete
					? () => {
							if (this.props.fixedPriceUtil) {
								this.props.fixedPriceUtil.addTask(task);
							}
							Util.CommitMutation(UndoDeleteTaskMutation, {
								ids: [task.id],
								projectId: this.props.viewer.project ? this.props.viewer.project.id : task.project.id,
							});
					  }
					: null,
			});
		};
		const callbackPositive = params => {
			if (this.props.fixedPriceUtil) {
				this.props.fixedPriceUtil.deleteTask(task.id);
			}
			const ids = [task.id];
			Util.CommitSchedulingModalUpdate(
				DeleteTaskMutation,
				{
					ids: ids,
					projectId: this.props.viewer.project ? this.props.viewer.project.id : task.project.id,
					filters: this.props.isConnectedParent ? [task.statusColumnV2.projectGroupStatusColumnId] : [task.statusColumnV2.id],
					viewer: this.props.viewer,
				},
				onSuccess
			);
		};

		let message = formatMessage({id: 'delete_task_modal.description'});

		if (task.hasTimeRegistrations && task.hasChildren) {
			message = formatMessage({id: 'delete-prompt.card-children-and-ime-entries-info'});
		} else if (task.hasChildren) {
			message = formatMessage({id: 'delete-prompt.card-children-info'});
		} else if (task.hasTimeRegistrations) {
			message = formatMessage({id: 'delete-prompt.card-time-entries-info'});
		}
		showModal({
			type: MODAL_TYPE.GENERIC,
			content: (
				<div>
					<Warning message={message} />
					<div className="warning-part-2">{formatMessage({id: 'common.warning.this_action_can_not_be_undone'})}</div>
				</div>
			),
			className: 'default-warning-modal',
			cy: 'modal-delete-task-button',
			buttons: [
				{
					text: formatMessage({id: 'common.cancel'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.WHITE,
					cy: 'cancel-modal-button',
				},
				{
					text: formatMessage({id: 'common.delete'}),
					callback: callbackPositive,
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.RED,
					cy: 'delete-modal-button',
				},
			],
		});
		this.setState({actionMenuExpanded: false});
	}

	blockTask(task) {
		if (task) {
			Util.CommitMutation(UpdateTaskMutationModern, {
				ids: [task.id],
				projectId: task.project.id,
				blocked: !task.blocked,
			});

			createToast({
				duration: 5000,
				message: !task.blocked ? this.props.intl.formatMessage({id: 'task_modal.has-been-blocked'}) : this.props.intl.formatMessage({id: 'task_modal.has-been-unblocked'}),
			});
		}
	}
	markAsBug(task) {
		if (task) {
			Util.CommitMutation(UpdateTaskMutationModern, {
				ids: [task.id],
				projectId: task.project.id,
				bug: !task.bug,
			});

			createToast({
				duration: 5000,
				message: !task.bug ? this.props.intl.formatMessage({id: 'task_modal.has-been-marked-as-bug'}) : this.props.intl.formatMessage({id: 'task_modal.has-been-unmarked-as-bug'}),
			});
		}
	}

	moveToAnotherProject(task) {
		const currentProjectId = this.props.viewer.project ? this.props.viewer.project.id : task.project.id;
		this.props.closeContextMenu();
		showModal({
			type: MODAL_TYPE.TASK_LOCATION,
			currentProjectId: currentProjectId,
			taskId: task.id,
			statusColumns: [task.statusColumnV2],
			onSuccess: () => {
				if (this.props.fixedPriceUtil) {
					this.props.fixedPriceUtil.deleteTask(task.id);
				}
			},
		});
	}

	openTimeRegistrationModal(task) {
		const project = this.props.viewer.project ? this.props.viewer.project : task.project;
		showModal({
			type: MODAL_TYPE.TIMER_V3,
			isPreviousTimerReminder: false,
			timerProject: project,
			timerTask: task,
			useTimer: false,
		});
	}

	stopTimer(task, preventedDelete) {
		const project = this.props.viewer.project
			? this.props.viewer.project
			: this.props.viewer.projectGroup
			? this.props.viewer.projectGroup.projects.edges.find(edge => edge.node.tasks.edges.find(taskEdge => taskEdge.node.id === task.id)).node
			: this.props.task.project;
		showModal({
			type: MODAL_TYPE.TIMER_V3,
			isPreviousTimerReminder: false,
			timerProject: project,
			timerTask: task,
			preventedDelete: preventedDelete,
		});
	}

	startTimer(task) {
		if (this.props.viewer.timerStartDate) {
			showModal({
				type: MODAL_TYPE.TIMER_V3,
				isPreviousTimerReminder: true,
				timerTask: this.props.viewer.timerTask ? this.props.viewer.timerTask : task,
			});
		} else {
			const onSuccess = result => {
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'timer.started_toast'})});
			};
			Util.CommitMutation(UpdateViewerMutation, {viewer: this.props.viewer, timerStartDate: Moment.utc().format(), timerEndDate: null, timerTaskId: task.id}, onSuccess);
		}
	}

	// END Menu options functionality //

	contextMenuFunction(func) {
		return () => {
			func();
			this.props.closeContextMenu();
		};
	}

	// BULK EDIT FUNCTIONALITY

	getBulkEditOptions() {
		const {formatMessage} = this.props.intl;

		if (this.props.selectedTasks.length === 0) {
			return [
				{
					text: formatMessage({id: 'bulk-edit.options-list-empty'}),
					disabled: true,
				},
			];
		}

		let bulk_update_options = [];
		const isJiraProject = this.props.viewer.project && this.props.viewer.project.isJiraProject;
		const isAdoProject = this.props.viewer.project && this.props.viewer.project.vstsProject;
		if (isJiraProject || isAdoProject) {
			bulk_update_options = [
				{text: formatMessage({id: 'project_section.bulk_move_cards_milesone'}), onClick: this.bulkUpdateMoveToPhase.bind(this)},
				{text: formatMessage({id: 'project_section.bulk_card_update'}), onClick: this.bulkUpdateTask.bind(this)},
			];
			if (isJiraProject) {
				const tasksWithoutJiraId = this.props.selectedTasks.filter(task => !task.jiraId).map(task => task.id);
				bulk_update_options.push({text: formatMessage({id: 'common.move_to_jira'}), onClick: this.moveToJira.bind(this, tasksWithoutJiraId), disabled: tasksWithoutJiraId.length === 0});
			}
			if (isAdoProject && this.props.viewer.project.vstsTwoWaySync) {
				const tasksWithoutAdoId = this.props.selectedTasks.filter(task => !task.vstsId).map(task => task.id);
				bulk_update_options.push({text: formatMessage({id: 'common.move_to_ado'}), onClick: this.moveToAdo.bind(this, tasksWithoutAdoId), disabled: tasksWithoutAdoId.length === 0});
			}
		} else {
			const invoiced = this.props.selectedTasks.some(t => t.hasInvoicedTime);
			const lockedTimeReg = this.props.selectedTasks.some(t => t.hasLockedTime);
			const hasLockedTask = this.props.selectedTasks.find(t => !t.userCanDeleteTask) !== undefined;
			if (hasFeatureFlag('bulk_select_context_menu', this.props.viewer.availableFeatureFlags)) {
				bulk_update_options = !this.props.viewer.project
					? [
							{text: formatMessage({id: 'project_section.bulk_card_update'}), onClick: this.bulkUpdateTask.bind(this)},
							{text: formatMessage({id: 'task_location_modal.title'}), onClick: this.bulkUpdateMoveToProject.bind(this), disabled: invoiced || lockedTimeReg},
							{
								text: formatMessage({id: 'common.delete'}),
								onClick: this.bulkUpdateDelete.bind(this),
								disabled: hasLockedTask,
								disabledDescription: formatMessage({id: 'invoicing.selection_contains_invoiced'}),
							},
					  ]
					: [
							{text: formatMessage({id: 'project_section.bulk_card_update'}), onClick: this.bulkUpdateTask.bind(this)},
							{text: formatMessage({id: 'task_location_modal.title'}), onClick: this.bulkUpdateMoveToProject.bind(this), disabled: invoiced || lockedTimeReg},
							{
								text: formatMessage({id: 'common.delete'}),
								onClick: this.bulkUpdateDelete.bind(this),
								disabled: hasLockedTask,
								disabledDescription: formatMessage({id: 'invoicing.selection_contains_invoiced'}),
							},
					  ];
			} else {
				/**
				 * TODO: Delete when/if bulk select context menu becomes permanent
				 */
				bulk_update_options = !this.props.viewer.project
					? [
							{text: formatMessage({id: 'project_section.bulk_card_update'}), onClick: this.bulkUpdateTask.bind(this)},
							{text: formatMessage({id: 'common.assign'}), onClick: this.bulkUpdateAssign.bind(this)},
							{text: formatMessage({id: 'bulk_update_option.move_to_sprint'}), onClick: this.bulkUpdateSprint.bind(this)},
							{text: formatMessage({id: 'task_location_modal.title'}), onClick: this.bulkUpdateMoveToProject.bind(this), disabled: invoiced || lockedTimeReg},
							{
								text: formatMessage({id: 'common.delete'}),
								onClick: this.bulkUpdateDelete.bind(this),
								disabled: hasLockedTask,
								disabledDescription: formatMessage({id: 'invoicing.selection_contains_invoiced'}),
							},
					  ]
					: [
							{text: formatMessage({id: 'project_section.bulk_card_update'}), onClick: this.bulkUpdateTask.bind(this)},
							{text: formatMessage({id: 'common.assign'}), onClick: this.bulkUpdateAssign.bind(this)},
							{text: formatMessage({id: 'project_section.bulk_move_cards_milesone'}), onClick: this.bulkUpdateMoveToPhase.bind(this)},
							{text: formatMessage({id: 'bulk_update_option.move_to_sprint'}), onClick: this.bulkUpdateSprint.bind(this)},
							{text: formatMessage({id: 'task_location_modal.title'}), onClick: this.bulkUpdateMoveToProject.bind(this), disabled: invoiced || lockedTimeReg},
							{
								text: formatMessage({id: 'common.delete'}),
								onClick: this.bulkUpdateDelete.bind(this),
								disabled: hasLockedTask,
								disabledDescription: formatMessage({id: 'invoicing.selection_contains_invoiced'}),
							},
					  ];
			}
		}

		return bulk_update_options;
	}

	bulkUpdateAssign() {
		const callbackPositive = selected => {
			const onSuccess = result => {
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'bulk_update.toast'})});
			};
			const assignedPersons = selected.map(el => el.value);
			Util.CommitMutation(
				UpdateTaskMutationModern,
				{
					ids: this.props.selectedTasks.map(t => t.id),
					assignedPersons: assignedPersons,
				},
				onSuccess
			);
		};

		const person_options = this.props.viewer.project
			? this.props.viewer.project.projectPersons.edges.map(pp => ({
					value: pp.node.person.id,
					label: pp.node.person.firstName + ' ' + pp.node.person.lastName,
					profilePictureId: pp.node.person.profilePictureId,
					profilePictureDefaultId: pp.node.person.profilePictureDefaultId,
			  }))
			: this.props.viewer.projectGroup.projects.edges[0].node.projectPersons.edges
					.filter(pp => !personIsClientUser(pp.node.person))
					.map(pp => ({
						value: pp.node.person.id,
						label: pp.node.person.firstName + ' ' + pp.node.person.lastName,
						profilePictureId: pp.node.person.profilePictureId,
						profilePictureDefaultId: pp.node.person.profilePictureDefaultId,
					}));

		showModal({
			type: MODAL_TYPE.SELECT,
			title: 'Assign to',
			defaultCallback: callbackPositive,
			options: person_options,
			label: 'Assigned',
			multi: true,
			initialValue: [],
			personSelect: true,
		});
		this.props.closeContextMenu();
	}

	compareSprintDates = (a, b) => {
		let aStartDate = Moment({
			y: a.node.startYear,
			M: a.node.startMonth - 1,
			d: a.node.startDay,
		});
		let aEndDate = Moment({
			M: a.node.endMonth - 1,
			y: a.node.endYear,
			d: a.node.endDay,
		});
		let bStartDate = Moment({
			y: b.node.startYear,
			M: b.node.startMonth - 1,
			d: b.node.startDay,
		});
		let bEndDate = Moment({
			y: b.node.endYear,
			M: b.node.endMonth - 1,
			d: b.node.endDay,
		});
		//Date used for sorting sprints with not selected dates
		const dummyDate = Moment({
			y: -10000,
			M: 1,
			d: 1,
		});

		if (!aStartDate.isValid()) aStartDate = dummyDate.clone();
		if (!aEndDate.isValid()) aEndDate = dummyDate.clone();
		if (!bStartDate.isValid()) bStartDate = dummyDate.clone();
		if (!bEndDate.isValid()) bEndDate = dummyDate.clone();

		if (aStartDate.isBefore(bStartDate)) return 1;
		if (bStartDate.isBefore(aStartDate)) return -1;
		//If same date, sort by end date ascending
		if (aEndDate.isBefore(bEndDate)) return 1;
		if (bEndDate.isBefore(aEndDate)) return -1;

		const aId = parseInt(atob(a.node.id).replace('Sprint:', ''), 10);
		const bId = parseInt(atob(b.node.id).replace('Sprint:', ''), 10);
		if (aId < bId) return 1;
		return -1;
	};

	bulkUpdateSprint() {
		const callbackPositive = selected => {
			const onSuccess = result => {
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'bulk_update.toast'})});
			};
			const mutationObject = {
				ids: this.props.selectedTasks.map(t => t.id),
			};
			if (this.props.viewer.project || !selected) {
				mutationObject.sprintId = selected ? selected.value : null;
			} else {
				mutationObject.projectGroupSprintId = selected.value;
			}
			Util.CommitMutation(UpdateTaskMutationModern, mutationObject, onSuccess);
		};
		const sprint_select_options = this.props.viewer.project
			? cloneDeep(this.props.viewer.project.sprints.edges)
					.sort(this.compareSprintDates)
					.map(sprint => ({value: sprint.node.id, label: sprint.node.name}))
			: cloneDeep(this.props.viewer.projectGroup.projects.edges[0].node.sprints.edges)
					.sort(this.compareSprintDates)
					.filter(sprint => sprint.node.isProjectGroupSprint)
					.map(sprint => ({value: sprint.node.projectGroupSprintId, label: sprint.node.name}));
		showModal({
			type: MODAL_TYPE.SELECT_V2,
			title: this.props.intl.formatMessage({id: 'project_section.bulk_move_cards_sprint'}),
			defaultCallback: callbackPositive,
			options: sprint_select_options,
			label: this.props.intl.formatMessage({id: 'common.sprint'}),
			multi: false,
			initialValue: null,
		});
		this.props.closeContextMenu();
	}

	bulkUpdateMoveToPhase() {
		const callbackPositive = selected => {
			const onSuccess = result => {
				this.props.unselectTasks();
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'bulk_update.toast'})});
			};
			Util.CommitMutation(
				UpdateTaskMutationModern,
				{
					ids: this.props.selectedTasks.map(t => t.id),
					phaseId: selected ? selected.value : null,
				},
				onSuccess
			);
		};
		const phase_select_options = this.props.viewer.project.phases.edges.map(phase => ({value: phase.node.id, label: phase.node.name}));
		this.props.closeContextMenu();

		showModal({
			type: MODAL_TYPE.SELECT_V2,
			title: this.props.intl.formatMessage({id: 'project_section.bulk_move_cards_milesone'}),
			defaultCallback: callbackPositive,
			options: phase_select_options,
			label: this.props.intl.formatMessage({id: 'common.scope-group'}),
			multi: false,
			initialValue: null,
		});
	}

	bulkUpdateMoveToProject() {
		// This should fetch both previous and target, but might need some revisiting if multi-selecting over 2+ projects.
		let currentProjectId;
		if (this.props.viewer.project) {
			currentProjectId = this.props.viewer.project.id;
		} else {
			currentProjectId = this.props.selectedTasks[0].project.id;
			if (
				this.props.selectedTasks.filter(t => {
					return t.project.id !== currentProjectId;
				}).length > 0
			) {
				currentProjectId = null; //multiple projects selected
			}
		}

		this.props.closeContextMenu();
		showModal({type: MODAL_TYPE.TASK_LOCATION, currentProjectId: currentProjectId, taskId: this.props.selectedTasks.map(task => task.id)});
		this.props.unselectTasks();
	}

	bulkUpdateTask() {
		const onSuccess = errors => {
			if (errors && errors.length !== 0) {
				Util.resolveTaskStatusErrors(errors, this.props.intl);
			} else {
				this.props.unselectTasks();
			}
		};
		if (!hasFeatureFlag('bulk_select_context_menu', this.props.viewer.availableFeatureFlags)) {
			const role_options = this.props.viewer.company.roles.edges.map(role => ({value: role.node.id, label: role.node.name}));
			const people_options = this.props.viewer.project
				? this.props.viewer.project.projectPersons.edges.map(pp => ({
						value: pp.node.person.id,
						label: pp.node.person.firstName + ' ' + pp.node.person.lastName,
						profilePictureId: pp.node.person.profilePictureId,
						profilePictureDefaultId: pp.node.person.profilePictureDefaultId,
				  }))
				: this.props.viewer.projectGroup.projects.edges[0].node.projectPersons.edges
						.filter(pp => !personIsClientUser(pp.node.person))
						.map(pp => ({
							value: pp.node.person.id,
							label: pp.node.person.firstName + ' ' + pp.node.person.lastName,
							profilePictureId: pp.node.person.profilePictureId,
							profilePictureDefaultId: pp.node.person.profilePictureDefaultId,
						}));

			const status_options = this.props.viewer.project
				? this.props.viewer.project.statusColumns
					? this.props.viewer.project.statusColumns.map(col => ({value: col.id, label: col.name}))
					: this.props.viewer.project.statusColumnsV2.edges.map(col => ({value: col.node.id, label: col.node.name, logo: col.node.jiraStatusId ? 'jira-logo' : undefined}))
				: this.props.viewer.projectGroup.projects.edges[0].node.statusColumnsV2.edges.map(col => ({
						value: col.node.id,
						label: col.node.name,
						logo: col.node.jiraStatusId ? 'jira-logo' : undefined,
				  }));

			const labels_options = this.props.viewer.company.labels.edges.map(label => ({value: label.node.id, label: label.node.name, color: label.node.color}));
			const estimationUnit = this.props.viewer.project ? this.props.viewer.project.estimationUnit : this.props.viewer.projectGroup.projects.edges[0].node.estimationUnit;

			this.props.closeContextMenu();
			showModal({
				type: MODAL_TYPE.BULK_TASK_UPDATE,
				language: this.props.viewer.language,
				role_options: role_options,
				people_options: people_options,
				status_options: status_options,
				labels_options: labels_options,
				companyId: this.props.viewer.company.id,
				isClientUser: isClientUser(),
				tasks: this.props.selectedTasks.map(t => t.id),
				estimationUnit: estimationUnit,
				removeLowHigh:
					(this.props.viewer.projectGroup ? this.props.viewer.projectGroup.projects.edges[0].node.estimationUnit : this.props.viewer.project.estimationUnit) === 'POINTS' ||
					this.props.viewer.availableFeatureFlags.some(flag => flag.key === 'remove_low_high'),
				saveCallback: onSuccess,
				isJiraProject: this.props.viewer.project ? this.props.viewer.project.isJiraProject : this.props.viewer.projectGroup.projects.edges[0].node.isJiraProject,
			});
		} else {
			this.props.closeContextMenu();
			showModal({
				type: MODAL_TYPE.BULK_TASK_UPDATE_STANDALONE,
				projectId: this.props.viewer.project ? this.props.viewer.project.id : this.props.task.project.id,
				projectGroupId: this.props.task.project.projectGroupId,
				companyId: this.props.viewer.company.id,
				isClientUser: isClientUser(),
				tasks: this.props.selectedTasks.map(t => t.id),
				saveCallback: onSuccess,
			});
		}
	}

	bulkUpdateDelete() {
		if (this.props.viewer.timerStartDate) {
			this.props.selectedTasks.forEach(task => {
				if (this.props.viewer.timerTask && task.id === this.props.viewer.timerTask.id) {
					this.stopTimer(task, true);
					return;
				}
			});
		}
		const callbackPositive = () => {
			const onSuccess = result => {
				this.props.unselectTasks();
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'bulk_delete.toast'})});
			};
			Util.CommitMutation(
				DeleteTaskMutation,
				{
					projectId: this.props.viewer.project ? this.props.viewer.project.id : this.props.task.project.id,
					ids: this.props.selectedTasks.map(t => t.id),
					filters: this.props.isConnectedParent ? this.props.selectedTasks.map(t => t.statusColumnV2.projectGroupStatusColumnId) : this.props.selectedTasks.map(t => t.statusColumnV2.id),
					viewer: this.props.viewer,
				},
				onSuccess
			);
		};
		this.props.closeContextMenu();

		showModal({
			type: MODAL_TYPE.GENERIC_DELETION_WARNING,
			deletedItems: this.props.selectedTasks,
			deleteCallback: callbackPositive,
		});
	}

	toggleBillable(task) {
		const onSuccess = result => {
			createToast({
				duration: 5000,
				message: !task.billable ? this.props.intl.formatMessage({id: 'task_modal.has-been-marked-billable'}) : this.props.intl.formatMessage({id: 'task_modal.has-been-unmarked-billable'}),
			});
		};
		Util.CommitMutation(
			UpdateTaskMutationModern,
			{
				ids: [task.id],
				billable: !task.billable,
			},
			onSuccess
		);
	}

	moveToJira(taskIds) {
		const project = this.props.viewer.project;
		if (project && taskIds && taskIds.length > 0) {
			showModal({
				type: MODAL_TYPE.CREATE_JIRA_ISSUE,
				projectId: `${project.companyProjectId}`,
				taskIds: taskIds,
				jiraType: project.jiraCloudProject || project.jiraCloudEpics?.length ? 'cloud' : 'server',
			});
			this.props.closeContextMenu();
		}
	}

	moveToAdo(taskIds) {
		const project = this.props.viewer.project;
		if (project && taskIds && taskIds.length > 0) {
			if (project.vstsProject && project.vstsAccount) {
				showModal({
					type: MODAL_TYPE.CREATE_ADO_WORKITEM,
					projectId: project.id,
					vstsAccount: project.vstsAccount,
					vstsArea: project.vstsArea,
					taskIds: taskIds,
				});
			}
			this.props.closeContextMenu();
		}
	}

	// END BULK EDIT FUNCTIONALITY

	getContextMenuOptions(task) {
		const {formatMessage} = this.props.intl;
		const {viewer} = this.props;
		const menuOptions = [];
		const userCanDelete = hasPermission(PERMISSION_TYPE.PROJECTS_UPDATE);

		//Do not show timer for clients and for users with time registration 
		if (!isClientUser() && !hasFeatureFlag('no_time_reg')) {
			const shouldShowStopTimerOption = viewer.timerStartDate && viewer.timerTask && task.id === viewer.timerTask.id;
			menuOptions.push({
				text: formatMessage({id: shouldShowStopTimerOption ? 'timer.stop' : 'timer.start'}),
				onClick: shouldShowStopTimerOption ? this.contextMenuFunction(this.stopTimer.bind(this, task)) : this.contextMenuFunction(this.startTimer.bind(this, task)),
			});
		}

		const project = task.project;

		// Save for later
		//actionMenuOptions.push({text: formatMessage({id: task.highPriority ? 'task-modal.unmark-priority' : 'task-modal.mark-priority'}), onClick: this.setPriority.bind(this, !task.highPriority)});

		//Everyone sees block/bug/duplicate options
		menuOptions.push({text: formatMessage({id: `card_modal.${task.blocked ? 'un' : ''}block-card`}), onClick: this.contextMenuFunction(this.blockTask.bind(this, task))});
		menuOptions.push({text: formatMessage({id: `card_modal.${task.bug ? 'un' : ''}mark-as-bug`}), onClick: this.contextMenuFunction(this.markAsBug.bind(this, task))});
		if (!task.jiraId) {
			menuOptions.push({text: formatMessage({id: 'common.duplicate'}), onClick: this.contextMenuFunction(this.duplicateTask.bind(this, task))});
		}

		//Only show billable option if project is billable
		if ((!viewer.company || !viewer.company.modules || Util.hasFinance(viewer.company.modules)) && project.billable && hasPermission(PERMISSION_TYPE.PROJECTS_UPDATE)) {
			menuOptions.push({text: formatMessage({id: `card_modal.${task.billable ? 'un' : ''}mark-billable`}), onClick: this.contextMenuFunction(this.toggleBillable.bind(this, task))});
		}

		const moveDisabledText = userCanDelete ? formatMessage({id: 'scheduling.task_move_locked'}) : formatMessage({id: 'common.no_move_rights'});
		//Do not allow changing project of the task if task is in a project that is connected to harvest/timelog or task is linked to jira
		if (!project.harvestProject && !task.jiraId && !project.timelogProject && !isClientUser() && !task.hasChildren && !task.parentTaskId) {
			menuOptions.push({
				text: formatMessage({id: 'task_location_modal.title'}),
				onClick: this.contextMenuFunction(this.moveToAnotherProject.bind(this, task)),
				disabled: !task.userCanDeleteTask,
				disabledDescription: moveDisabledText,
				cy: 'move-to-another-project-option',
			});
		}
		if (!isClientUser() && !hasFeatureFlag('no_time_reg')) {
			menuOptions.push({text: formatMessage({id: 'card_modal.add-time'}), onClick: this.contextMenuFunction(this.openTimeRegistrationModal.bind(this, task)), cy: 'action-add-time'});
		}
		const startingDate = Util.CreateNonUtcMomentDate(task.startYear, task.startMonth, task.startDay);
		const today = Moment();
		const meetingOptions = {
			title: `T${task.companyTaskId} - ${task.name} - meeting`,
			attendees: task.assignedPersons.filter(p => p.email).map(per => per.email),
			startTime: startingDate && today.isBefore(startingDate) ? Moment(startingDate.toDate()).set('h', 8).startOf('h') : today.startOf('h').add(1, 'h'),
			endTime: startingDate && today.isBefore(startingDate) ? Moment(startingDate.toDate()).set('h', 9).startOf('h') : today.startOf('h').add(2, 'h'),
			organizerEmail: viewer.email,
			organizerName: ((viewer.firstName ? viewer.firstName : '') + ' ' + (viewer.lastName ? viewer.lastName : '')).trim(),
			description: task.description ? Util.ConvertDraftJsToPlainText(task.description, '%0A') : '',
		};
		menuOptions.push({
			text: formatMessage({id: 'meeting_creator.create_google_meeting'}),
			onClick: this.contextMenuFunction(() => Util.googleCalendarExport(meetingOptions)),
		});
		menuOptions.push({
			text: formatMessage({id: 'meeting_creator.create_client_meeting'}),
			onClick: this.contextMenuFunction(() => Util.iCalExport(meetingOptions)),
		});

		if (project.isJiraProject && !task.jiraId) {
			menuOptions.push({
				text: formatMessage({id: 'common.move_to_jira'}),
				onClick: this.contextMenuFunction(this.moveToJira.bind(this, [task.id])),
			});
		}
		if (project.vstsProject && project.vstsTwoWaySync && !task.vstsId) {
			menuOptions.push({
				text: formatMessage({id: 'common.move_to_ado'}),
				onClick: this.contextMenuFunction(this.moveToAdo.bind(this, [task.id])),
			});
		}

		menuOptions.push({
			text: formatMessage({id: 'common.delete'}),
			onClick: this.contextMenuFunction(this.deleteTask.bind(this, task)),
			disabled: !task.userCanDeleteTask,
			disabledDescription: getCantDeleteTaskMessage(this.props.intl, task.userCantDeleteTaskReason),
			cy: 'delete-task',
		});
		return menuOptions;
	}

	handleKeyDown(option, e) {
		if (e.keyCode === 27) {
			//escape
			if (this.props.closeContextMenu) {
				this.props.closeContextMenu();
			}
		} else if (e.keyCode === 32 || e.keyCode === 13) {
			//enter or space
			if (option.onClick) {
				option.onClick();
			}
		} else if (e.keyCode === 38) {
			//arrow up
			if (this.state.focusAtIndex !== 0) {
				this.setState({focusAtIndex: this.state.focusAtIndex - 1});
			}
		} else if (e.keyCode === 40) {
			//arrow down
			if (this.state.focusAtIndex !== this.options.length - 1) {
				this.setState({focusAtIndex: this.state.focusAtIndex + 1});
			}
		}
	}

	handleBlur(e) {
		const newTarget = e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
		if (newTarget && this.list_container && this.list_container.contains(newTarget)) return;
		else {
			this.props.closeContextMenu();
		}
	}

	render() {
		this.options = this.props.customOptions ? this.props.customOptions : this.props.bulkEdit ? this.getBulkEditOptions(this.props.task) : this.getContextMenuOptions(this.props.task);
		const w = Math.max(document.documentElement.clientWidth, window.innerWidth);
		const openLeft = this.props.contextMenuOpenLeft || Math.abs(w - this.props.contextMenuPosition.x) <= 190;
		return ReactDOM.createPortal(
			<ul
				ref={ul => (this.list_container = ul)}
				onBlur={this.handleBlur.bind(this)}
				className="task-context-menu"
				data-cy={this.props.cy}
				style={{top: this.props.contextMenuPosition.y, left: this.props.contextMenuPosition.x - (openLeft ? 195 : 0)}}
				role="menu"
			>
				{this.options.map((option, index) =>
					option.icon === 'download' || option.icon === 'open' ? (
						<li data-cy={option.cy} className="context-menu-option download-option" key={index} role="menuitem">
							<a
								className="file-download"
								//for some reason when '?123 is added after file id it downloads file with correct filename otherwise filename is ignored'
								href={option.link ? option.link : option.fileSrc}
								target={option.link ? '_blank' : ''}
								ref={el => {
									this['option_' + index] = el;
								}}
								onKeyDown={this.handleKeyDown.bind(this, option)}
								onClick={option.onClick && !option.disabled ? option.onClick.bind(this) : null}
							>
								<div id="context-menu-option" className={'option-icon ' + option.icon + (option.disabled ? ' disabled' : '')} />
								<span id="context-menu-option">{option.text}</span>
							</a>
						</li>
					) : (
						<li
							data-cy={option.cy}
							title={option.disabled ? option.disabledDescription : option.description}
							className={'context-menu-option' + (option.disabled ? ' disabled' : '')}
							key={index}
							id="context-menu-option"
							onClick={option.onClick && !option.disabled && !option.locked ? option.onClick.bind(this) : null}
							tabIndex={0}
							ref={el => {
								this['option_' + index] = el;
							}}
							onKeyDown={this.handleKeyDown.bind(this, option)}
							role="menuitem"
						>
							<div id="context-menu-option" className={'option-icon ' + option.icon} />
							<span id="context-menu-option">{option.text}</span>
						</li>
					)
				)}
				{this.props.bulkEdit ? (
					<div className={'selected-tasks-count-indicator'}>
						<div className={'count-text'}>{this.props.selectedTasks.length}</div>
					</div>
				) : null}
			</ul>,
			document.querySelector('#root-portal-container')
		);
	}
}

GenericTaskContextMenu.propTypes = {
	unselectTasks: PropTypes.func,
};

export default injectIntl(GenericTaskContextMenu);
